<form [formGroup]="form">
  <p-accordion [value]="activeCharacteristicIndex">
    @for (
      characteristic of characteristicsControls();
      track characteristic;
      let index = $index
    ) {
      <p-accordion-panel [value]="index">
        <p-accordion-header>
          <div class="me-4 flex flex-1 items-center justify-between gap-4">
            <div class="flex items-center gap-2 text-sm text-gray-400">
              <div class="flex gap-1 font-bold">
                <span>#{{ index + 1 }}</span>
                <span>
                  {{ labelForGroup(characteristic) | async }}
                </span>
              </div>
            </div>

            <div>
              <p-button
                (onClick)="handleRemoveClick(index)"
                appPrimengButton
                label="Usuń"
                severity="danger" />
            </div>
          </div>
        </p-accordion-header>

        <p-accordion-content>
          <div class="flex flex-col">
            <app-form-control label="Etykieta charakterystyki">
              <input
                pInputText
                appPrimengInputText
                placeholder="Wprowadź etykietę charakterystyki"
                [fluid]="true"
                [formControl]="characteristic.controls.label" />
            </app-form-control>

            <app-form-control label="Treść charakterystyki">
              <app-summernote
                [height]="120"
                [formControl]="characteristic.controls.content" />
            </app-form-control>
          </div>
        </p-accordion-content>
      </p-accordion-panel>
    } @empty {
      <div class="rounded-sm border border-gray-200 p-4">
        <div class="mb-2 italic">Brak charakterystyk boxa.</div>

        <p-button
          (onClick)="handleAddClick()"
          [fluid]="true"
          appPrimengButton
          label="Dodaj charakterystykę boxa"
          size="small" />
      </div>
    }

    @if (isNotEmptyArray(characteristicsControls())) {
      <div class="mt-3 flex flex-col">
        <p-button
          (onClick)="handleAddClick()"
          [fluid]="true"
          appPrimengButton
          label="Dodaj charakterystykę boxa"
          size="small" />
      </div>
    }
  </p-accordion>
</form>
